import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "clone",
  "use": "clone-usage",
  "viewBox": "0 0 67 67",
  "content": "<symbol viewBox=\"0 0 67 67\" id=\"clone\"><title>资源 116</title><g id=\"clone_图层_2\" data-name=\"图层 2\"><g id=\"clone_图层_1-2\" data-name=\"图层 1\"><path d=\"M46.06,54.44h4.19v4.19A8.38,8.38,0,0,1,41.88,67H8.38A8.38,8.38,0,0,1,0,58.63V25.13a8.38,8.38,0,0,1,8.38-8.37h4.19v4.19H8.38a4.19,4.19,0,0,0-4.19,4.19v33.5a4.19,4.19,0,0,0,4.19,4.19h33.5a4.19,4.19,0,0,0,4.19-4.19ZM67,8.38v33.5a8.38,8.38,0,0,1-8.37,8.38H25.13a8.37,8.37,0,0,1-8.37-8.37V8.38A8.37,8.37,0,0,1,25.13,0h33.5A8.38,8.38,0,0,1,67,8.38Zm-4.19,0a4.19,4.19,0,0,0-4.19-4.19H25.13a4.19,4.19,0,0,0-4.19,4.19v33.5a4.19,4.19,0,0,0,4.19,4.19h33.5a4.19,4.19,0,0,0,4.19-4.19Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/clone.svg
// module id = Y3To
// module chunks = 264